import React,{ Component } from 'react';
import { Progress } from 'reactstrap'


class FakeProgess extends Component {
  constructor(){
    super();

    this.state = {
      value:0
    }
  }

  componentDidMount(){
    this.timer = window.setInterval(() => this.tickForward(),100);
  }

  componentWillUnmount(){
    window.clearInterval(this.timer);
  }

  tickForward(){
    this.setState({
      value:this.state.value + (100 - this.state.value) / 2
    });
  }

  render(){
    return (
      <Progress
        value={this.state.value}
        color='danger'
      />
    )
  }
}

FakeProgess.defaultProps = {
  timeout:10
};

export default FakeProgess;



// WEBPACK FOOTER //
// ./src/shared/components/FakeProgress/index.js